import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bbd522c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-column" }
const _hoisted_2 = { class: "left-top" }
const _hoisted_3 = { class: "left-bottom" }
const _hoisted_4 = { class: "right-column" }
const _hoisted_5 = { class: "right-info" }
const _hoisted_6 = { class: "right-chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingMask = _resolveComponent("LoadingMask")!
  const _component_StrategyTable = _resolveComponent("StrategyTable")!
  const _component_PositionPanel = _resolveComponent("PositionPanel")!
  const _component_StrategyInfo = _resolveComponent("StrategyInfo")!
  const _component_YieldChart = _resolveComponent("YieldChart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["subscription-view", { 'theme-light': !_ctx.isDark }]),
    style: _normalizeStyle(_ctx.themeVars)
  }, [
    _createVNode(_component_LoadingMask, {
      visible: _ctx.unsubscribeLoading,
      text: _ctx.isTraditional ? '正在移除訂閱，請稍候…' : '正在移除订阅，请稍候…',
      isDark: _ctx.isDark
    }, null, 8, ["visible", "text", "isDark"]),
    _createVNode(_component_LoadingMask, {
      visible: _ctx.listLoading && _ctx.strategyList.length === 0,
      text: _ctx.isTraditional ? '加載中，請稍候…' : '加载中，请稍候…',
      isDark: _ctx.isDark
    }, null, 8, ["visible", "text", "isDark"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_StrategyTable, {
          list: _ctx.strategyList,
          selectedCode: _ctx.selectedCode,
          isTraditional: _ctx.isTraditional,
          isDark: _ctx.isDark,
          prefer: _ctx.prefer,
          loading: _ctx.listLoading,
          unsubscribeLoading: _ctx.unsubscribeLoading,
          onSelect: _ctx.selectStrategy,
          onUnsubscribe: _ctx.handleUnsubscribe
        }, null, 8, ["list", "selectedCode", "isTraditional", "isDark", "prefer", "loading", "unsubscribeLoading", "onSelect", "onUnsubscribe"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PositionPanel, {
          code: _ctx.selectedCode,
          isTraditional: _ctx.isTraditional,
          defaultRange: '3M'
        }, null, 8, ["code", "isTraditional"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_StrategyInfo, {
          strategy: _ctx.selectedStrategy,
          isTraditional: _ctx.isTraditional
        }, null, 8, ["strategy", "isTraditional"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_YieldChart, {
          market: _ctx.selectedStrategy?.market || 'HK',
          code: _ctx.selectedCode,
          isTraditional: _ctx.isTraditional
        }, null, 8, ["market", "code", "isTraditional"])
      ])
    ])
  ], 6))
}